import { render } from "./ListCreditRec.vue?vue&type=template&id=2bac702d&scoped=true"
import script from "./ListCreditRec.vue?vue&type=script&lang=js"
export * from "./ListCreditRec.vue?vue&type=script&lang=js"

import "./ListCreditRec.vue?vue&type=style&index=0&id=2bac702d&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bac702d"]])

export default __exports__